import { render, staticRenderFns } from "./EnrollmentsTable.vue?vue&type=template&id=4da2dd0a"
import script from "./EnrollmentsTable.vue?vue&type=script&lang=ts"
export * from "./EnrollmentsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports